
  import React from "react"
  import Component from "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/src/layouts/index.jsx"
  import data from "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js